import React from "react";

export const renderImportantMetric = (cell) => {

    const isCritical = cell.data.critical;

    return (
        <span style={{ color: isCritical ? "rgb(234,134,143)" : "inherit", fontWeight: isCritical ? "bold" : "normal" }}>
            {cell.value}
        </span>
    )
};